import FieldIconButton from '../../../../../components/FieldIconButton/FieldIconButton';
import Inline from '../../../../../components/Inline/Inline';
import NumericField from '../../../../../components/NumericField/NumericField';
import Select from '../../../../../components/Select/Select';
import useTrans from '../../../../../hooks/ui/useTrans';
import BoatModelCategory from '../../../../types/BoatModelCategory';
import passengersIcon from '../../graphics/passengersIcon.svg?raw';

type BoatModelFiltersProps = {
    categories: Array<BoatModelCategory>;
    selectedCategory: string | undefined; // undefined means all, empty string means no category
    onCategoryChange: (id: string) => void;
    minimumPassengers: number | undefined;
    onMinimumPassengersChange: (value: number | undefined) => void;
};

const BoatModelFilters = ({
    categories,
    selectedCategory,
    minimumPassengers,
    onCategoryChange,
    onMinimumPassengersChange,
}: BoatModelFiltersProps) => {
    const trans = useTrans('CustomerArea.BookingForm.BoatModelFilters.');

    const categoryOptions = categories.map((cat) => ({
        value: cat.id,
        label: cat.name,
    }));

    const handlePassengersChange = (value: string) => {
        if (value === '') {
            onMinimumPassengersChange(undefined);

            return;
        }

        const numericValue = parseInt(value);
        if (!numericValue) {
            return;
        }

        onMinimumPassengersChange(numericValue);
    };

    return (
        <Inline vertical="middle">
            <Select
                placeholder={trans('CategoriesPlaceholder')}
                options={categoryOptions}
                value={selectedCategory}
                onChange={onCategoryChange}
            />
            <NumericField
                placeholder={trans('PassengersPlaceholder')}
                value={minimumPassengers ? minimumPassengers.toString() : ''}
                onChange={handlePassengersChange}
                min={1}
            >
                <FieldIconButton icon={passengersIcon} variant="subtle" />
            </NumericField>
        </Inline>
    );
};

export default BoatModelFilters;
